import api from './axios';

export const backupConfigAPI = {
  getAll: async (page = 1, limit = 10, isActive = true) => {
    const response = await api.get('/backup-configs', {
      params: { page, limit, isActive },
    });
    return response.data;
  },

  getByInstallation: async (uniqueId) => {
    const response = await api.get(`/installation/${uniqueId}/backup-configs`);
    return response.data;
  },

  create: async (uniqueId, data) => {
    const response = await api.post(`/installation/${uniqueId}/backup-config`, data);
    return response.data;
  },

  update: async (configId, data) => {
    const response = await api.put(`/backup-config/${configId}`, data);
    return response.data;
  },

  delete: async (configId) => {
    const response = await api.delete(`/backup-config/${configId}`);
    return response.data;
  },
};
